import FfCamIcon from '../../images/ff-camera-icon.svg';
import DrCamIcon from '../../images/dr-camera-icon.svg';
import PaCamIcon from '../../images/pa-camera-icon.svg';
import ReCamIcon from '../../images/re-camera-icon.svg';
import { ADPLUS2_DVR_CAMERAS, STANDARD_DVR_CAMERAS, TWO_CHANNEL_DVR_CAMERAS } from '../../util/dvrCameras';

// Cameras per machine type
export const fourChannelsConfiguration = [
  {
    name: 'forwardFacing',
    channel: 0
  },
  {
    name: 'rear',
    channel: 2
  },
  {
    name: 'driver',
    channel: 3
  },
  {
    name: 'passenger',
    channel: 1
  }
];

const twoChannelsConfiguration = [
  {
    name: 'forwardFacing',
    channel: 0
  },
  {
    name: 'rear',
    channel: 1
  }
];

const camerasPerMachineType = machineType => {
  if (machineType === 1) {
    return twoChannelsConfiguration;
  }

  return fourChannelsConfiguration;
};

export default camerasPerMachineType;

// TO CONSIST THE MACHINETYPE 0 and 2 to 4CHAN and 1 and 4 for 2CHAN
export const MACHINE_TYPE = {
  FOUR_CAM: 0,
  TWO_CAM: 1,
  ADPLUSTWO_CAM: 4,
  get: machineType => {
    if (machineType === MACHINE_TYPE.TWO_CAM) {
        return MACHINE_TYPE.TWO_CAM;
    }

    return MACHINE_TYPE.FOUR_CAM;
  }
};

// ENUM TO RETURN AN ARRAY WITH CAMERA ICONS; used in CameraViews (OnDemand)
export const CAMERA_VIEWS = {
  get: machineType => {
    if (machineType === 1) {
      return TWO_CHANNEL_DVR_CAMERAS;
    } else if(machineType === 4){
      return ADPLUS2_DVR_CAMERAS;
    }
    return STANDARD_DVR_CAMERAS;
  }
};

